(function() {
    'use strict';
    angular.module('porting', [ 'ngSanitize', 'mnp.config'
    ]);
})();
